<template>
  <div class="col5-of-12">
    <label class="is-required">
      First Name
      <input
        data-hj-allow
        type="text"
        placeholder="John"
        :value="userInfo.data.firstName"
        @change="handleChange({ key: 'firstName', value: $event.target.value })"
      />
      <span v-if="userInfo.firstNameError" class="error-text">{{
        userInfo.firstNameError
      }}</span>
    </label>
    <label class="is-required">
      Last Name
      <input
        data-hj-allow
        type="text"
        placeholder="Doe"
        :value="userInfo.data.lastName"
        @change="handleChange({ key: 'lastName', value: $event.target.value })"
      />
      <span v-if="userInfo.lastNameError" class="error-text">{{
        userInfo.lastNameError
      }}</span>
    </label>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  data() {
    return {
      firstNameError: false,
      lastNameError: false,
    };
  },
  methods: {
    ...mapActions({
      updateUser: 'userAccount/updateUserName',
      markDirty: 'userAccount/markDirty',
      markError: 'userAccount/markNameError',
    }),
    handleChange(payload) {
      this.markError(payload);
      this.updateUser(payload);
      this.markDirty('name');
    },
  },
  computed: {
    ...mapGetters({
      userInfo: 'userAccount/userInfo',
    }),
  },
};
</script>
